import React, { useEffect, useState } from "react";
import { Row, Col, Collapse } from "antd";
import apiClient from "../../Actions/apiClient";
import { sanitizeHTML } from "../../Util/Util";
import "./Agenda.scss";
import { FiChevronDown, FiChevronUp, FiClock } from "react-icons/fi";

const { Panel } = Collapse;

export default function AgendaList({ title }) {
  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    if (!title) return;

    apiClient.get("events/list").then(({ data }) => {
      if (data.result && Array.isArray(data.result)) {
        // find event whose title matches the prop
        const eventDetails = data.result.find(
          (item) => item.title?.toLowerCase() === title.toLowerCase()
        );
        setDataSource(eventDetails || null);
      }
    });
  }, [title]);

  console.log("dataSource", dataSource);

  if (!dataSource) return null; // prevent render before data load

  return (
    <section className="faq agenda spacing" data-aos="fade-up">
      <div className="container">
        <Row
          gutter={[
            { xs: 0, sm: 16, md: 24, lg: 32 },
            { xs: 0, sm: 16, md: 24, lg: 20 },
          ]}
          className="pb-3"
          align="center"
        >
          <Col xs={24} sm={24} md={18} lg={18}>
            <div className="highlight-title" data-aos="fade-up">
              <div className="mb-2 ">
                <h3 className="text-primary text-center mb-0">{dataSource.title}</h3>

                {dataSource.subtitle && (
                  <h5 className="text-primary text-center fst-italic mb-1">
                    {dataSource.subtitle}
                  </h5>
                )}

                <div className="text-center mt-3">
                  <h4 className="title mb-2 text-primary fw-bold">Agenda</h4>
                </div>

                {dataSource.agendas && dataSource.agendas.length > 0 ? (
                  <Collapse
                    expandIconPosition="right"
                    expandIcon={({ isActive }) =>
                      isActive ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />
                    }
                  >
                    {dataSource.agendas.map((agendaList, i) => (
                      <Panel
                        header={
                          <span className="text-uppercase text-primary">
                            <span>Day {i + 1} :</span>
                            <span className="ms-3 font-weight-bold">
                              {agendaList.agendaMainTitle}
                            </span>
                          </span>
                        }
                        key={i}
                        className="custom-panel"
                      >
                        <div className="agenda-list">
                          {agendaList.agendaItems?.map((agendas, j) => (
                            <div className="list" key={j}>
                              <div className="details d-flex flex-column flex-md-row align-items-left justify-content-between border-top">
                                <div className="time d-flex align-items-center">
                                  <FiClock size={16} className="text-primary me-1" />
                                  <span className="text-gray">{agendas.menuTime}</span>
                                </div>

                                <div className="notes">
                                  <div className="title-desc">
                                    <h6
                                      className="font-weight-bold text-primary text-uppercase mt-2 mb-1"
                                      style={{ lineHeight: "150%" }}
                                    >
                                      {agendas.menuTitle}
                                    </h6>
                                    {agendas.menuDesc && (
                                      <div
                                        className="agenda-description d-block text-gray"
                                        dangerouslySetInnerHTML={{
                                          __html: sanitizeHTML(agendas.menuDesc),
                                        }}
                                      />
                                    )}
                                  </div>

                                  {agendas.speaker && (
                                    <div className="speaker-details d-flex align-items-center mt-2">
                                      <div
                                        className="speaker-info d-block text-gray"
                                        dangerouslySetInnerHTML={{
                                          __html: sanitizeHTML(agendas.speaker),
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Panel>
                    ))}
                  </Collapse>
                ) : (
                  <p className="text-muted mt-3">Agenda details coming soon.</p>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}
